import React from 'react';
import { Link } from 'react-router-dom';
import { UserMenu } from './UserMenu';

interface DashboardHeaderProps {
  title?: string;
  showAnalysisNav?: boolean;
  analysisId?: string;
  isDashboardPage?: boolean;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ title, showAnalysisNav, analysisId, isDashboardPage = false }) => {

  return (
    <header className="fixed top-0 left-0 right-0 bg-transparent backdrop-blur-sm border-b border-gray-200/10 dark:border-gray-800/10 z-50">
      <div className="container max-w-screen-2xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link 
            to="/dashboard" 
            className="flex items-center text-xl font-bold text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 transition-colors"
          >
            <img src="/i-can-pitch-logo.jpg" alt="Logo" className="h-8 w-auto mr-2" />
            ICanPitch
          </Link>
          {title && (
            <h1 className="text-xl font-semibold text-gray-800 dark:text-gray-200">
              {title}
            </h1>
          )}
        </div>
        <div className="flex items-center gap-4">
          <UserMenu showLogout={true} />
        </div>
        
        {showAnalysisNav && (
          <nav className="flex items-center space-x-4 mt-2">
            <Link 
              to={`/analysis/${analysisId}`}
              className="px-4 py-2 rounded-lg bg-indigo-600 text-white"
            >
              Analysis
            </Link>
            <Link 
              to={`/valuation/${analysisId}`}
              className="px-4 py-2 text-gray-600 hover:text-indigo-600"
            >
              Valuation
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};
